<template>
  <div class="flex w-full">
    <article class="card">
      <div class="flex sm:flex-wrap md:flex-no-wrap ">
        <div class="card-hero-image">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 30 20"
            class="p-6 w-24 simple-svg"
          >
            <path
              fill-rule="evenodd"
              d="M.133 19.774a.617.617 0 0 0 .418.222.754.754 0 0 0 .074.004h25.347a.618.618 0 0 0 .607-.447L29.98 6.612a.56.56 0 0 0-.115-.504.638.638 0 0 0-.491-.226H27.5v-2.94c0-.326-.28-.59-.625-.59H10.443L7.585.135A.654.654 0 0 0 7.188 0H.625C.28 0 0 .264 0 .588V19.4a.582.582 0 0 0 .133.374zM28.576 7.06l-3.093 11.765H1.423L4.519 7.059h24.058zM1.25 1.176h5.713l2.856 2.22a.66.66 0 0 0 .398.133H26.25v2.353H4.027a.618.618 0 0 0-.606.447L1.25 14.585V1.176z"
            />
          </svg>
        </div>
        <div class="card-content">
          <small v-text="'FOLDER SHARED'" />
          <h3 class="-mb-2">
            {{ name }} shared a folder titled "{{ folderTitle }}" with you.
          </h3>
          <div
            class="mt-2 text-sm text-grey-dark"
            v-text="date"
          />
          <a
            :href="actionLink"
            class="mt-4"
            v-text="'View Folder'"
          />
        </div>
      </div>
    </article>
  </div>
</template>

<script type="text/babel">
import ActivityItemMixin from '../../mixins/ActivityItemMixin'

export default {
  name: 'FolderWasSharedToGroupOrMembershipsEvent',
  mixins: [ActivityItemMixin],
  computed: {
    folderTitle() {
      return this.item.subject.attributes.title
    },
    actionLink() {
      return this.$urlGenerator.active(`documents/folders/${this.item.subject.uuid}`)
    },
  },
}
</script>
